// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Description__Description__ovdZT div:first-child{z-index:0}
`, "",{"version":3,"sources":["webpack://./src/js/apps/workflow/components/NewInbox/Common/Description/Description.scss"],"names":[],"mappings":"AAAA,iDAEQ,SAAU","sourcesContent":[".Description {\n    div:first-child {\n        z-index: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Description": `Description__Description__ovdZT`
};
export default ___CSS_LOADER_EXPORT___;
